const deviceModule = {
  namespaced: true,
  /**
   * basicInfo    基本資訊
   *    name         名稱
   *    ip           ip
   *    building     棟別
   *    enableDate   啟用日期
   *    floor        樓層
   *    district     區域
   *    deviceType   設備類型
   *    mac          MAC
   * cardInfo     卡片資訊
   *    sort         排序
   *    number       卡片號碼
   */
  state: {
    deviceFormItem: [
      {
        label: '名稱',
        prop: 'name',
        type: 'input',
        required: true
      },
      {
        label: 'ip',
        prop: 'ip',
        type: 'input',
        required: true
      },
      {
        label: '棟別',
        prop: 'building',
        type: 'select',
        required: true
      },
      {
        label: '啟用日期',
        prop: 'enableDate',
        type: 'input',
        required: false
      },
      {
        label: '樓層',
        prop: 'floor',
        type: 'select',
        required: true
      },
      {
        label: '區域',
        prop: 'district',
        type: 'select',
        required: false
      },
      {
        label: '設備類型',
        prop: 'type',
        type: 'input',
        required: true
      },
      {
        label: 'MAC',
        prop: 'mac',
        type: 'input',
        required: true
      }
    ],
    basicInfo: {
      name: { value: '' },
      ip: { value: '111.111.111' },
      building: {
        options: [
          {
            label: 'A棟',
            value: 'A'
          },
          {
            label: 'B棟',
            value: 'B'
          }
        ],
        value: ''
      },
      enableDate: { value: '2023/12/22' },
      floor: {
        options: [
          {
            label: 'A棟',
            value: 'A'
          },
          {
            label: 'B棟',
            value: 'B'
          }
        ],
        value: ''
      },
      district: {
        options: [
          {
            label: 'A棟',
            value: 'A'
          },
          {
            label: 'B棟',
            value: 'B'
          }
        ],
        value: ''
      },
      type: { value: '' },
      mac: { value: '' }
    },
    cardInfo: []
  },
  getters: {
    getDeviceFormItem: (state) => state.deviceFormItem,
    getBasicInfo: (state) => state.basicInfo,
    getCardInfo: (state) => state.cardInfo
  },
  mutations: {
    updateData(state, { basicInfo, cardInfo }) {
      Object.entries(basicInfo).forEach(([key, value]) => {
        if (state.basicInfo[key]) {
          state.basicInfo[key].value = value
        }
      })
      state.cardInfo = cardInfo
    }
  },
  actions: {
    update({ commit }, payload) {
      const { basicInfo, cardInfo } = payload
      commit('updateData', {
        basicInfo,
        cardInfo
      })
    }
  }
}

export default deviceModule
